import React from 'react';
import { cn } from '@/lib/utils';
import { InputLabel } from '@/components/ui/InputLabel';

export function InputNumberWithSuffix({
  label,
  suffix = 'personnes',
  value,
  onChange,
  className,
  inputClassName,
  ...props
}: {
  label: string;
  suffix?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  inputClassName?: string;
  min?: number;
  max?: number;
  maxLength?: number;
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>['inputMode'];
  disabled?: boolean;
  id?: string;
}) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value === '') {
      onChange({ ...e, target: { ...e.target, value: '0' } });
      return;
    }

    let cleanValue = value.replace(/^0+/, '') || '0';
    let numericValue = parseInt(cleanValue, 10);

    if (isNaN(numericValue) || numericValue < 0) return;
    if (props.max !== undefined && numericValue > props.max) {
      cleanValue = String(props.max);
    }

    onChange({ ...e, target: { ...e.target, value: cleanValue } });
  };

  return (
    <div className={cn('relative', className)}>
      <InputLabel
        label={label}
        className={cn('w-60 pr-24', inputClassName)}
        min={props.min ?? 0}
        max={props.max}
        inputMode="numeric"
        maxLength={props.maxLength ?? 6}
        value={value}
        onChange={handleChange}
        disabled={props.disabled}
        id={props.id}
      />
      <p
        className={cn(
          'absolute top-0.5 right-3 text-base translate-y-1/2 pointer-events-none',
          props.disabled ? 'text-disable' : 'text-tertiary',
        )}
      >
        {suffix}
      </p>
    </div>
  );
}
